<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="recentchanges">2. Recent Changes</h2>
          <p>Use this map to see the hotspots where your landscape has changed the most during the past 12 months.</p>

          <p>To see the hotspots for a specific month, click on the data in the column for that month. For each dataset only the top 25 hotspots larger than 1 hectare appear on the map. The table under the map shows the total area of alerts, including those smaller than 1 hectare. </p>

          <p>Select a hotspot on the map to compare satellite images from before and after the change. Try selecting different time periods to get the best view of how the area has changed. </p>

          <p>The map shows all datasets that are available monthly in this region. The current month may not always be complete, and can still be updated throughout the month. </p>

        <AlertMap 
          title="Recent Changes" 
          attribution="Maps: Geofolio Landscape Reports. Data: GFW [14]/ RADD Alerts [13]/Planet NICFI [7]. Backgrounds: Mapbox/Openstreetmap Contributors [13]/Planet NICFI composites/ESA WorldCover." 
          numSlots="9" 
          slotType="monthly" 
          sources="images_forest_alerts,glad_forest_loss_alerts,wur_radd_alerts" 
          v-bind:location="location" 
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
           >
        </AlertMap>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import AlertMap from '@/components/factsheet/ldr/maps/AlertMap.vue'
    
    export default {
        name: 'Alerts',
        components: { AlertMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
              
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>